import { render, staticRenderFns } from "./exitSupervision.vue?vue&type=template&id=2c6b778d&scoped=true"
import script from "./exitSupervision.vue?vue&type=script&lang=js"
export * from "./exitSupervision.vue?vue&type=script&lang=js"
import style0 from "./exitSupervision.vue?vue&type=style&index=0&id=2c6b778d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b778d",
  null
  
)

export default component.exports